import * as tslib_1 from "tslib";
import React from 'react';
import { throttle } from 'lodash';
export default function debounceRender(ComponentToDebounce, wait, options) {
  return (
    /** @class */
    function (_super) {
      tslib_1.__extends(DebouncedContainer, _super);

      function DebouncedContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;

        _this.updateDebounced = throttle(_this.forceUpdate, wait, options);
        return _this;
      }

      DebouncedContainer.prototype.shouldComponentUpdate = function () {
        this.updateDebounced();
        return false;
      };

      DebouncedContainer.prototype.componentWillUnmount = function () {
        this.updateDebounced.cancel();
      };

      DebouncedContainer.prototype.render = function () {
        // @ts-ignore
        return React.createElement(ComponentToDebounce, tslib_1.__assign({}, this.props));
      };

      return DebouncedContainer;
    }(React.Component)
  );
}